<template>
  <PmSettingsRequestPure
    v-model:form-data="formData"
    :state="state.path.value"
    :error="state.snapshot.context.error"
    :saved-form-data="savedFormData"
    @submit="(variables) => state.send({ type: 'save', variables })"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { fromPromise } from 'xstate5'
import { useXState } from '@/composition/useXState5'
import { PmSettingsRequestState } from './PmSettingsRequestState'
import PmSettingsRequestPure, {
  type Emits as EmitsSettingsRequestPure,
  type Props as PropsSettingsRequestPure,
  type Models as ModelsSettingsRequestPure,
} from './PmSettingsRequestPure.vue'
import { useStore } from 'vuex'
import { useUserSettings } from '@/composition/useUserSettings'

const store = useStore()
const userSettings = useUserSettings()

const state = useXState(
  PmSettingsRequestState.provide({
    actions: {
      showSuccessNotification: () => {
        console.log('show success')

        store.commit('notification/add', {
          variant: 'success',
          title: 'Einstellungen Anfrage gespeichert',
        })
      },
    },

    actors: {
      save: fromPromise(async ({ input }) => save(input.variables)),
    },
  })
)

const formData = ref<ModelsSettingsRequestPure['formData']>({
  sendCopyToMe: userSettings.settings.value['request.sendCopyToMe'],
})

const savedFormData = computed<PropsSettingsRequestPure['savedFormData']>(
  () => ({
    sendCopyToMe: userSettings.settings.value['request.sendCopyToMe'],
  })
)
async function save(variables: EmitsSettingsRequestPure['submit'][0]) {
  await userSettings.save({ 'request.sendCopyToMe': variables.sendCopyToMe })
}
</script>
